import { formValueSelector } from 'redux-form';

export default form => formValueSelector(form);
